<div class="ds-banner__icon">
    <uilab-icon icon="notifications--warning"></uilab-icon>
</div>
<ng-content selector="[bannerContent]"></ng-content>

<ng-content selector="[bannerEnd]"></ng-content>
